import { z } from 'zod';

export const LiabilitiesInputSchema = z.object({
    eventId: z.number().optional(),
    oldTradingEventId: z.number().optional(),
    marketId: z.number(),
    type: z.enum(['old-trading', 'new-trading']).optional(),
});

export type TrpcLiabilitiesInputSchemaType = z.infer<typeof LiabilitiesInputSchema>;

export const SinglesLiabilitiesResponseSchema = z.object({
    overround: z.number().optional().nullable(),
    selections: z.array(
        z.object({
            id: z.string().nullish(),
            oldTradingId: z.string().nullish(),
            name: z.string().optional().nullable(),
            price: z
                .object({
                    d: z.number(),
                    f: z.string(),
                })
                .optional()
                .nullable(),
            result: z
                .object({
                    place: z.number().optional().nullable(),
                    type: z.string(),
                })
                .optional()
                .nullable(),
            sgl: z.object({
                bets: z.number(),
                payout: z.number(),
                plRatio: z.number(),
                placePayout: z.number(),
                placeStakes: z.number(),
                profit: z.number(),
                stakes: z.number(),
                totalCashOutBets: z.number(),
                totalCashOutPayout: z.number(),
                totalCashOutStakes: z.number(),
            }),
            spPrice: z
                .object({
                    d: z.number(),
                    f: z.string(),
                })
                .optional()
                .nullable(),
        })
    ),
    sgl: z.object({
        bets: z.number(),
        placeStakes: z.number(),
        stakes: z.number(),
        totalCashOutBets: z.number(),
        totalCashOutPayout: z.number(),
        totalCashOutStakes: z.number(),
    }),
});

export type TrpcSinglesLiabilitiesResponseType = z.infer<typeof SinglesLiabilitiesResponseSchema>;

export const MultiplesLiabilitiesResponseSchema = z.object({
    overround: z.number().optional().nullable(),
    selections: z.array(
        z.object({
            id: z.string().nullish(),
            oldTradingId: z.string().nullish(),
            name: z.string().optional().nullable(),
            price: z
                .object({
                    d: z.number(),
                    f: z.string(),
                })
                .optional()
                .nullable(),
            result: z
                .object({
                    place: z.number().optional().nullable(),
                    type: z.string(),
                })
                .optional()
                .nullable(),
            sgl: z.object({
                expPayout: z.number(),
                netPayout: z.number(),
                openBetsNum: z.number(),
                openStakes: z.number(),
                rumLines: z.number(),
                rumPayout: z.number(),
                rumStakes: z.number(),
                totalBetsNum: z.number(),
                totalStakes: z.number(),
                totalStakesPercent: z.number(),
            }),
            spPrice: z
                .object({
                    d: z.number(),
                    f: z.string(),
                })
                .optional()
                .nullable(),
        })
    ),
    sgl: z
        .object({
            bets: z.number(),
            placeStakes: z.number(),
            stakes: z.number(),
            totalCashOutBets: z.number(),
            totalCashOutPayout: z.number(),
            totalCashOutStakes: z.number(),
        })
        .optional()
        .nullable(),
});

export type TrpcMultiplesLiabilitiesResponseType = z.infer<typeof MultiplesLiabilitiesResponseSchema>;
